{
	"errors": {
		"cycles": {
			"unrecognized cycle": {
				"userMessage": "api-errors.cycles.unrecognized-cycle",
				"catchError": false,
				"onError": null
			},
			"cycle id exists": {
				"userMessage": "api-errors.cycles.cycle-id-exists",
				"catchError": true,
				"onError": null
			},
			"unmatching status": {
				"userMessage": "api-errors.cycles.unmatching-status",
				"catchError": false,
				"onError": null
			},
			"file error": {
				"userMessage": "api-errors.cycles.file-error",
				"catchError": true,
				"onError": null
			},
			"unmatching field type": {
				"userMessage": "api-errors.cycles.unmatching-field-type",
				"catchError": true,
				"onError": null
			},
			"station in process": {
				"userMessage": "api-errors.cycles.station-in-process",
				"catchError": true,
				"onError": null
			},
			"unrecognized user": {
				"userMessage": "api-errors.cycles.unrecognized-user",
				"catchError": true,
				"onError": null
			},
			"unrecognized template": {
				"userMessage": "api-errors.cycles.unrecognized-template",
				"catchError": true,
				"onError": null
			},
			"invalid station": {
				"userMessage": "api-errors.cycles.invalid-station",
				"catchError": true,
				"onError": null
			},
			"multiple templates": {
				"userMessage": "api-errors.cycles.multiple-templates",
				"catchError": true,
				"onError": null
			},
			"template name exists": {
				"userMessage": "api-errors.cycles.template-name-exists",
				"catchError": true,
				"onError": null
			},
			"no name": {
				"userMessage": "api-errors.cycles.no-name",
				"catchError": true,
				"onError": null
			},
			"field page exceeds page count": {
				"userMessage": "api-errors.cycles.field-page-exceeds-page-count",
				"catchError": true,
				"onError": null
			},
			"field value doesn't match type": {
				"userMessage": "api-errors.cycles.field-value-doesnt-match-type",
				"catchError": true,
				"onError": null
			},
			"unrecognized metatag": {
				"userMessage": "api-errors.cycles.unrecognized-metatag",
				"catchError": true,
				"onError": null
			},
			"duplicate metatag": {
				"userMessage": "api-errors.cycles.duplicate-metatag",
				"catchError": true,
				"onError": null
			},
			"unrecognized trigger": {
				"userMessage": "api-errors.cycles.unrecognized-trigger",
				"catchError": true,
				"onError": null
			},
			"template locked": {
				"userMessage": "api-errors.cycles.template-locked",
				"catchError": true,
				"onError": null
			},
			"trigger error": {
				"id": "trigger_error",
				"userMessage": "api-errors.cycles.trigger-error",
				"catchError": false,
				"onError": null
			},
			"unrecognized userMessage provider": {
				"userMessage": "api-errors.cycles.unrecognized-userMessage-provider",
				"catchError": true,
				"onError": null
			},
			"invalid field index": {
				"userMessage": "api-errors.cycles.invalid-field-index",
				"catchError": true,
				"onError": null
			},
			"notification failed for one or more users": {
				"userMessage": "api-errors.cycles.notification-failed-for-one-or-more-users"
			}
		},
		"users": {
			"unrecognized user": {
				"userMessage": "api-errors.users.unrecognized-user",
				"catchError": true,
				"onError": null
			},
			"user id exists": {
				"userMessage": "api-errors.users.user-id-exists",
				"catchError": true,
				"onError": null
			},
			"username exists": {
				"userMessage": "api-errors.users.username-exists",
				"catchError": true,
				"onError": null
			},
			"email exists": {
				"userMessage": "api-errors.users.email-exists",
				"catchError": true,
				"onError": null
			},
			"phone exists": {
				"userMessage": "api-errors.users.phone-exists",
				"catchError": true,
				"onError": null
			},
			"username inactive": {
				"userMessage": "api-errors.users.username-inactive",
				"catchError": true,
				"onError": null
			},
			"email inactive": {
				"userMessage": "api-errors.users.email-inactive",
				"catchError": true,
				"onError": null
			},
			"phone inactive": {
				"userMessage": "api-errors.users.phone-inactive",
				"catchError": true,
				"onError": null
			},
			"invalid password": {
				"userMessage": "api-errors.users.invalid-password",
				"catchError": true,
				"onError": null
			},
			"empty password": {
				"userMessage": "api-errors.users.empty-password",
				"catchError": true,
				"onError": null
			},
			"no image": {
				"userMessage": "api-errors.users.no-image",
				"catchError": true,
				"onError": null
			},
			"invalid file": {
				"userMessage": "api-errors.users.invalid-file",
				"catchError": true,
				"onError": null
			},
			"name exists": {
				"userMessage": "api-errors.users.name-exists",
				"catchError": true,
				"onError": null
			},
			"file not found": {
				"userMessage": "api-errors.users.file-not-found"
			}
		},
		"metaTags": {
			"duplicate metatag": {
				"userMessage": "api-errors.meta-tags.duplicate-metatag",
				"catchError": true,
				"onError": null
			},
			"unknown metatag": {
				"userMessage": "api-errors.meta-tags.unknown-metatag"
			}
		},
		"forms": {
			"unrecognized form": {
				"userMessage": "api-errors.forms.unrecognized-form",
				"catchError": true,
				"onError": null
			},
			"unrecognized user": {
				"userMessage": "api-errors.forms.unrecognized-user",
				"catchError": true,
				"onError": null
			},
			"file not found": {
				"userMessage": "api-errors.forms.file-not-found"
			}
		},
		"auth": {
			"invalid request": {
				"userMessage": "api-errors.auth.invalid-request",
				"catchError": true,
				"onError": null
			},
			"unrecognized tenant": {
				"userMessage": "api-errors.auth.unrecognized-tenant",
				"catchError": true,
				"onError": null
			},
			"empty username": {
				"userMessage": "api-errors.auth.empty-username",
				"catchError": true,
				"onError": null
			},
			"empty password": {
				"userMessage": "api-errors.auth.empty-password",
				"catchError": true,
				"onError": null
			},
			"unrecognized user": {
				"userMessage": "api-errors.auth.unrecognized-user",
				"catchError": false,
				"onError": null
			},
			"no match": {
				"userMessage": "api-errors.auth.no-match",
				"catchError": true,
				"onError": {
					"navTo": "login"
				}
			},
			"locked out": {
				"userMessage": "api-errors.auth.locked-out",
				"catchError": true,
				"onError": {
					"navTo": "login/locked"
				}
			},
			"not allowed": {
				"userMessage": "api-errors.auth.not-allowed",
				"catchError": true,
				"onError": null
			},
			"two factor": {
				"userMessage": "api-errors.auth.two-factor",
				"catchError": true,
				"onError": null
			},
			"disabled user": {
				"userMessage": "api-errors.auth.disabled-user",
				"catchError": true,
				"onError": {
					"navTo": "login/disabled"
				}
			},
			"unrecognized refresh token": {
				"userMessage": "api-errors.auth.unrecognized-refresh-token"
			}
		},
		"validations": {
			"duplicate validation rule": {
				"userMessage": "api-errors.validation.duplicate-validation-rule",
				"catchError": true,
				"onError": null
			},
			"locked validation rule": {
				"userMessage": "api-errors.validation.locked-validation-rule",
				"catchError": true,
				"onError": null
			},
			"unknown validation rule": {
				"userMessage": "api-errors.validation.unknown-validation-rule",
				"catchError": true,
				"onError": null
			},
			"unlicensed module": {
				"userMessage": "api-errors.validation.unlicensed-module"
			}
		},
		"admin": {
			"unrecognized tenant": {
				"userMessage": "api-errors.admin.unrecognized-tenant",
				"catchError": true,
				"onError": null
			},
			"id exists": {
				"userMessage": "api-errors.admin.id-exists",
				"catchError": true,
				"onError": null
			},
			"company id empty": {
				"userMessage": "api-errors.admin.company-id-empty",
				"catchError": true,
				"onError": null
			},
			"company ph empty": {
				"userMessage": "api-errors.admin.company-ph-empty",
				"catchError": true,
				"onError": null
			},
			"name exists": {
				"userMessage": "api-errors.admin.name-exists",
				"catchError": true,
				"onError": null
			},
			"host exists": {
				"userMessage": "api-errors.admin.host-exists",
				"catchError": true,
				"onError": null
			},
			"name empty": {
				"userMessage": "api-errors.admin.name-empty",
				"catchError": true,
				"onError": null
			},
			"no hosts": {
				"userMessage": "api-errors.admin.no-hosts",
				"catchError": true,
				"onError": null
			},
			"duplicated host": {
				"userMessage": "api-errors.admin.duplicated-host",
				"catchError": true,
				"onError": null
			},
			"server empty": {
				"userMessage": "api-errors.admin.server-empty",
				"catchError": true,
				"onError": null
			},
			"connectionstring empty": {
				"userMessage": "api-errors.admin.connectionstring-empty",
				"catchError": true,
				"onError": null
			},
			"filepath empty": {
				"userMessage": "api-errors.admin.filepath-empty"
			}
		}
	}
}
